import * as React from 'react';
import { useSelector } from 'react-redux';
import * as styles from './DemandBannerContainer.css';
import { DiscountBanner } from './components/DiscountBanner';
import { HighDemandBanner } from './components/HighDemandBanner';
import { useDeviceCondition } from '../../hooks';
import { selectIsCommercialCategory } from '../../selectors/offer/selectIsCommercialCategory';
import { selectHighDemandCoefficient } from '../../reducers/v2/paidPublication/selectors/selectHighDemandCoefficient';

export const DemandBannerContainer = () => {
  const highDemandCoefficient = useSelector(selectHighDemandCoefficient);
  const isCommercial = useSelector(selectIsCommercialCategory);
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  if (!highDemandCoefficient || highDemandCoefficient === 1 || !isCommercial) {
    return null;
  }

  if (highDemandCoefficient > 1) {
    return (
      <div className={rootStyle}>
        <HighDemandBanner />
      </div>
    );
  }

  return (
    <div className={rootStyle}>
      <DiscountBanner />
    </div>
  );
};
